"use strict";

import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import { PromiseDelay, DataSource, classMixer } from 'generics/utils';
import { SourceListener } from 'generics/dataBound';
import { BootButton, CloseButton } from 'generics/buttons';
import MoneyUtil from 'components/moneyUtil';
import { MarketCancelOrder } from 'api/marketAPICall';
import { MarketOrders } from 'api/ordersAPICall';

const logger =  LogStream("CANCELALLORDERS");
// LogStream.enable( "CANCELALLORDERS" );

const loggerErrors =  LogStream("CANCELALLORDERSERROR");
LogStream.enable( "CANCELALLORDERSERROR" );

export const ordersList = new DataSource({
    buyOrders:[],
    buyOrdersTotal:0,
    sellOrders:[],
    sellOrdersTotal:0,
  });


function reducerOrdersTotal( accum, order )  {
  const  {  normalPrice,  localPrice,  currency,  amount,  doneAmount,  } = order;
  const price = MoneyUtil.preferMoney(normalPrice, localPrice, currency, currency);
  return accum + (price * (amount||0))
}


const  ordersByTime = (l,r) => (r.time - l.time);


function setOrders(orders)  {

  const buyOrders = orders.filter( it => (it.type == 'BUY') ).sort(ordersByTime);
  const buyOrdersTotal = buyOrders.reduce( reducerOrdersTotal, 0 );

  const sellOrders = orders.filter( it => (it.type == 'SELL') ).sort(ordersByTime);
  const sellOrdersTotal = sellOrders.reduce( reducerOrdersTotal, 0 );

  ordersList.update({
      buyOrders,
      buyOrdersTotal,
      sellOrders,
      sellOrdersTotal
    });
}


ordersList.on(orders  =>  {
    logger.debug( "ordersList(", orders, ")" );
  });


export class CancelOrdersPanel extends React.Component  {
  constructor(props)  {
    super(props);
    this.state = {
        stage : "loading",

        processedBuy : 0,
        processedSell : 0,

        errors : "",
      };
  }


  componentDidMount()  {
    PromiseDelay(
      300,
      MarketOrders()

    ).catch(  (reason) =>  {
      loggerErrors.error("Failed to load own orders data:", reason)
      return [];

    }).then( (resp) =>  {
      logger.info( "CancelOrdersPanel:orders loaded -> ", resp );
      resp = resp||[];
      setOrders(resp);
      return resp.length;

    }).then( (count) =>  {
      if ( count )  {
        this.setState({"stage":"loaded"});
      }  else  {
        this.setState({"stage":"none"});
      }

    });
  }


  componentWillUnmount()  {
  }


  onCancelError = ( current, err )  =>  {
    loggerErrors.warning( "Failed MarketCancelOrder(",current.pairId, current.id, " -> ", err );

    this.setState((prevState, props)  =>  {
      const errors = [
          prevState.errors,
          _I_("CancelOrdersPanel.cancelError"),
          `${current.id}`,
          current.mid ? " / "+current.mid : "",
        ].join("");
      return { errors };
    });
  }
  

  countCancelStep = ( current, resp )  =>  {
    loggerErrors.info( "MarketCancelOrder(",current.pairId, current.id, " -> ", resp );

    this.setState((prevState, props)  =>  {
      if (current.type=="BUY")  {
        return {processedBuy: 1+prevState.processedBuy}
      }  else  {
        return {processedSell: 1+prevState.processedSell}
      }
    });
  }


  doCancelStep = ([ current, ...rest ])  =>  {
    return MarketCancelOrder(
        current.pairId, current.id

      ).catch( err  =>  {
        this.onCancelError( current, err );
        return err;

      }).then( resp  =>  {
        this.countCancelStep( current, resp )
        return PromiseDelay(300);
      }).then( ()  =>  {
        if ( rest.length )  {
          return this.doCancelStep(rest);
        }  else  {
          return true;
        }

      });
  }


  doCancelOrders = () =>  {
    this.setState({"stage":"cancelling"});
    const { buyOrders, sellOrders } = ordersList.get();
    this.doCancelStep(
        [ ...buyOrders, ...sellOrders ]
      ).then( () => {
        this.setState({"stage":"done"});
      });
  }


  render()  {
    const  { stage, processedBuy, processedSell, errors }  =  this.state;
    switch ( stage )  {
      case "loading":
        return (<CancelOrdersLoading stage={stage} />);
  
      case "loaded":
        return (<SourceListener orders={ordersList} >{({orders,}) => (
            <CancelOrdersLoaded stage={stage} orders={orders}
                                doCancelOrders={this.doCancelOrders} />
          )}</SourceListener>);

      case "cancelling":
        return (<SourceListener orders={ordersList} >{({orders,}) => (
            <CancelOrdersCancelling stage={stage} orders={orders}
                                    processedBuy={processedBuy}
                                    processedSell={processedSell} />
          )}</SourceListener>);

      case "done":
        return (<CancelOrdersDone stage={stage} errors={errors} />);

      case "none":
          // fallback
      default:
        return null; // all other cases
    }
  }
};


defineSimpleTerm( "CancelOrdersPanel.cancelError",  "\nFailed to cancel order ",       {
  "ru_RU": "\nНе удалось отменить ордер ",
  "cs_CZ": "\nFailed to cancel order",
  "fr_FR": "\nEchec de l'annulation de la commande",
  "de_DE": "\nStornierung der Bestellung abgebrochen",
  "it_IT": "\nCancellazione ordine fallita",
  "ko_KR": "\n주문 취소에 실패하였습니다",
  "pl_PL": "\nNie udało się anulować polecenia",
  "pt_PT": "\nFailed to cancel order",
  "es_ES": "\nNo se pudo cancelar el pedido",
  "zh_CN": "\n取消订单失败 ",
  "zh_TW": "\n取消訂單失敗 "
} );

function PricePad({ price, market="gjn" })  {
  return (<i>{!!price && MoneyUtil.formatMoney(price, market)}</i>);
}


function CancelOrdersLoading({ stage })  {
  return (
      <div className="alert alert-primary" >
        <div className="text-center">
        {_I_("CancelOrdersPanel.loading")}
        </div>
      </div>
    );
}


defineSimpleTerm( "CancelOrdersPanel.loading",  "Checking active orders",       {
  "ru_RU": "Проверка списка ордеров",
  "cs_CZ": "Checking active orders",
  "fr_FR": "Vérification des commandes en cours",
  "de_DE": "Aktive Aufträge überprüfen",
  "it_IT": "Controllo ordini attivi",
  "ko_KR": "거래 주문 확인",
  "pl_PL": "Sprawdzanie aktywnych transakcji",
  "pt_PT": "Checking active orders",
  "es_ES": "Comprobando pedidos activos",
  "zh_CN": "检查有效订单",
  "zh_TW": "檢查有效訂單"
} );


function CancelOrdersDone({ stage, errors })  {
  return (
      <div className="alert alert-primary" >
        <div className="text-center">
        {_I_("CancelOrdersPanel.done")}
        {(!!errors)&&(
          <pre>
            {_I_("CancelOrdersPanel.errors")}
            {errors}
          </pre>
        )}
        </div>
      </div>
    );
}


defineSimpleTerm( "CancelOrdersPanel.done",  "Operation finished.",       {
  "ru_RU": "Операция завершена.",
  "cs_CZ": "Operation finished.",
  "fr_FR": "Opération terminée.",
  "de_DE": "Vorgang abgeschlossen.",
  "it_IT": "Operazione terminata.",
  "ko_KR": "작업이 완료되었습니다.",
  "pl_PL": "Operacja zakończona.",
  "pt_PT": "Operation finished.",
  "es_ES": "Operación terminada.",
  "zh_CN": "操作已完成。",
  "zh_TW": "操作已完成。"
} );


defineSimpleTerm( "CancelOrdersPanel.errors",  "Got some errors: \n",       {
  "ru_RU": "Возникли ошибки: \n",
  "cs_CZ": "Got some errors: \n",
  "fr_FR": "Il y a des erreurs: \n",
  "de_DE": "Fehler aufgetreten: \n",
  "it_IT": "Qualche errore: \n",
  "ko_KR": "에러가 발생하였습니다: \n",
  "pl_PL": "Pojawiły się błędy: \n",
  "pt_PT": "Got some errors: \n",
  "es_ES": "Hay algunos errores: \n",
  "zh_CN": "有一些错误：\n",
  "zh_TW": "有一些錯誤：\n"
} );


function CancelOrdersLoaded({ stage, orders, doCancelOrders })  {
  const  { sellOrders, sellOrdersTotal, buyOrders, buyOrdersTotal }  =  orders;

  const haveBuy = !!(buyOrders && buyOrders.length);
  const haveSell = !!(sellOrders && sellOrders.length);
  return (
      <div className="alert alert-primary" >
        <div className="text-center">
          {_I_("CancelOrdersPanel.loaded.youHave")}
          {haveSell && (<span className="text-info">
            {sellOrders.length}
            {_I_("CancelOrdersPanel.loaded.sellOrders")}
            <PricePad price={sellOrdersTotal} />
          </span>)}

          {(haveSell && haveBuy) &&  _I_("CancelOrdersPanel.loaded.and")}

          {haveBuy && (<span className="text-info">
            {buyOrders.length}
            {_I_("CancelOrdersPanel.loaded.buyOrders")}
            <PricePad price={buyOrdersTotal} />
          </span>)}

          {_I_("CancelOrdersPanel.loaded.shouldCancel")}
        </div>
        <div className="text-center">
          <BootButton  variant="success" block onClick={doCancelOrders} >
            {_I_("CancelOrdersPanel.loaded.doCancel")}
          </BootButton>
        </div>
      </div>
    );
}


defineSimpleTerm( "CancelOrdersPanel.loaded.youHave",  "Currently you have ",       {
  "ru_RU": "На текущий момент у вас выставлены ",
  "cs_CZ": "Currently you have ",
  "fr_FR": "Actuellement, vous avez ",
  "de_DE": "Im Moment hast du ",
  "it_IT": "Attualmente hai ",
  "ko_KR": "현재 소유중 ",
  "pl_PL": "Obecnie posiadasz ",
  "pt_PT": "Currently you have ",
  "es_ES": "Actualmente tienes ",
  "zh_CN": "目前你拥有 ",
  "zh_TW": "目前你擁有 "
} );


defineSimpleTerm( "CancelOrdersPanel.loaded.sellOrders",  " sell order(s) totalling to ",       {
  "ru_RU": " ордер(а/ов) на продажу на сумму ",
  "cs_CZ": " sell order(s) totalling to ",
  "fr_FR": " total d(es) ordre(s) des vente ",
  "de_DE": " Aufträge verkaufen von insgesamt ",
  "it_IT": " ordini di vendita in totale ",
  "ko_KR": " 전체 판매 주문량 ",
  "pl_PL": " polecenia sprzedaży sumują się do ",
  "pt_PT": " sell order(s) totalling to ",
  "es_ES": " órden(es) de venta por un total de ",
  "zh_CN": " 卖出订单总计 ",
  "zh_TW": " 賣出訂單總計 "
} );


defineSimpleTerm( "CancelOrdersPanel.loaded.buyOrders",  " buy order(s) totalling to ",       {
  "ru_RU": " ордер(а/ов) на покупку на сумму ",
  "cs_CZ": " buy order(s) totalling to ",
  "fr_FR": " total d(es) ordre(s) d'achat ",
  "de_DE": " Aufträge kaufen von insgesamt ",
  "it_IT": " ordini d'acquisto in totale ",
  "ko_KR": " 전체 구매 주문량 ",
  "pl_PL": " polecenia kupna sumują się do ",
  "pt_PT": " buy order(s) totalling to ",
  "es_ES": " orden(es) de compra por un total de ",
  "zh_CN": " 买出订单总计 ",
  "zh_TW": " 賣出訂單總計 "
} );


defineSimpleTerm( "CancelOrdersPanel.loaded.and",  " and ",       {
  "ru_RU": " и ",
  "cs_CZ": " and ",
  "fr_FR": " et ",
  "de_DE": " und ",
  "it_IT": " e ",
  "ko_KR": " 과(와) ",
  "pl_PL": " i ",
  "pt_PT": " and ",
  "es_ES": " y ",
  "zh_CN": " 与 ",
  "zh_TW": " 與 "
} );


defineSimpleTerm( "CancelOrdersPanel.loaded.shouldCancel",  " and you have to cancel them all. ",       {
  "ru_RU": " и вам необходимо их все отменить. ",
  "cs_CZ": " and you have to cancel them all. ",
  "fr_FR": " et vous devez tous les annuler. ",
  "de_DE": " und du musst sie alle abbrechen. ",
  "it_IT": " e devi cancellarli tutti. ",
  "ko_KR": " 를 취소해 주셔야 합니다. ",
  "pl_PL": " i musisz anulować je wszystkie. ",
  "pt_PT": " and you have to cancel them all. ",
  "es_ES": " y tienes que cancelarlas todas. ",
  "zh_CN": " 你必须全部取消。 ",
  "zh_TW": " 你必須全部取消。 "
} );


defineSimpleTerm( "CancelOrdersPanel.loaded.doCancel",  "Cancel orders",       {
  "ru_RU": "Отменить ордера",
  "cs_CZ": "Cancel orders",
  "fr_FR": "Annuler les commandes",
  "de_DE": "Aufträge abbrechen",
  "it_IT": "Cancella ordini",
  "ko_KR": "주문 취소하기",
  "pl_PL": "Anuluj polecenia",
  "pt_PT": "Cancel orders",
  "es_ES": "Cancelar pedidos",
  "zh_CN": "取消订单",
  "zh_TW": "取消訂單"
} );



function CancelOrdersCancelling({ stage, orders, processedBuy, processedSell })  {
  const  { sellOrders, buyOrders }  =  orders;

  const haveSell = !!(sellOrders && sellOrders.length);
  const haveBuy = !!(buyOrders && buyOrders.length);
  return (
    <div className="alert alert-primary" >
      <div className="text-center">
        {_I_("CancelOrdersPanel.cancelling.processing")}
      </div>

      {haveBuy && (<div className="text-center">
          <span className="text-info">
            {processedBuy}
            {_I_("CancelOrdersPanel.cancelling.outOf")}
            {buyOrders.length}
          </span>
          {_I_("CancelOrdersPanel.cancelling.buyOrders")}
        </div>)}

      {haveSell && (<div className="text-center">
          <span className="text-info">
            {processedSell}
            {_I_("CancelOrdersPanel.cancelling.outOf")}
            {sellOrders.length}
          </span>
          {_I_("CancelOrdersPanel.cancelling.sellOrders")}
        </div>)}
    </div>);
}


defineSimpleTerm( "CancelOrdersPanel.cancelling.processing",  "Processing",       {
  "ru_RU": "Обрабатываются",
  "cs_CZ": "Processing",
  "fr_FR": "En cours",
  "de_DE": "Bearbeiten",
  "it_IT": "In processo",
  "ko_KR": "진행중",
  "pl_PL": "Przetwarzanie",
  "pt_PT": "Processing",
  "es_ES": "Procesando",
  "zh_CN": "处理中",
  "zh_TW": "處理中"
} );


defineSimpleTerm( "CancelOrdersPanel.cancelling.outOf",  " out of ",       {
  "ru_RU": " из ",
  "cs_CZ": " out of ",
  "fr_FR": " pas de ",
  "de_DE": " nicht im ",
  "it_IT": " di ",
  "ko_KR": " 주문량 없음 ",
  "pl_PL": " brak ",
  "pt_PT": " out of ",
  "es_ES": " fuera de ",
  "zh_CN": " / ",
  "zh_TW": " / "
} );


defineSimpleTerm( "CancelOrdersPanel.cancelling.sellOrders",  " sell orders",       {
  "ru_RU": " ордеров на продажу",
  "cs_CZ": " sell orders",
  "fr_FR": " ordres de vente",
  "de_DE": " Aufträge verkaufen",
  "it_IT": " ordini di vendita",
  "ko_KR": " 구매",
  "pl_PL": " polecenia sprzedaży",
  "pt_PT": " sell orders",
  "es_ES": " pedidos de venta",
  "zh_CN": " 出售订单",
  "zh_TW": " 出售訂單"
} );


defineSimpleTerm( "CancelOrdersPanel.cancelling.buyOrders",  " buy orders",       {
  "ru_RU": " ордеров на покупку",
  "cs_CZ": " buy orders",
  "fr_FR": " ordres d'achat",
  "de_DE": " Aufträge kaufen",
  "it_IT": " ordini d'acquisto",
  "ko_KR": " 판매",
  "pl_PL": " polecenia kupna",
  "pt_PT": " buy orders",
  "es_ES": " pedidos de compra",
  "zh_CN": " 购买订单",
  "zh_TW": " 購買訂單"
} );

